import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'PeaksSports',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-KBEB2NVV39']
    })
  ]
})

export { analytics }
